/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Download_BlockedInputs */

const en_google_drive_download_blocked = /** @type {(inputs: Google_Drive_Download_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading is not allowed for this file.`)
};

const es_google_drive_download_blocked = /** @type {(inputs: Google_Drive_Download_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se permite descargar este archivo.`)
};

/**
* | output |
* | --- |
* | "Downloading is not allowed for this file." |
*
* @param {Google_Drive_Download_BlockedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_download_blocked = /** @type {((inputs?: Google_Drive_Download_BlockedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Download_BlockedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_download_blocked(inputs)
	return en_google_drive_download_blocked(inputs)
});